
import { BuilderContext } from "@Context/game/builder/builder-context";
import { faMinusCircle, faPlusCircle } from "@fortawesome/pro-solid-svg-icons";
import useI18n from "@i18n";
import { useTheme } from '@mui/material';
import '@pixi/events';
import { Menu, MenuItem } from "@spaceymonk/react-radial-menu";
import { useContext, useEffect, useState } from "react";
import { deleteWaypoint, getSelectedPlayer } from './functions/player-functions';
import { Player, TargetMode } from './models/builder-data-types';
import RadialItem from './radial-item';

const WaypointMenu = () => {

  const { state, dispatch } = useContext(BuilderContext);
  const { i18n } = useI18n();
  const [selectedPlayer, setSelectedPlayer] = useState<Player | undefined>(undefined);
  const theme = useTheme();

  useEffect(() => {
    setSelectedPlayer(getSelectedPlayer(state));
  }, [state.selectedPlayer]);

  const handleInsertBeforeClick = () => {
    dispatch({ targetMode: TargetMode.InsertWaypointBefore, showWaypointRadial: false });
  };

  const handleInsertAfterClick = () => {
    dispatch({ targetMode: TargetMode.InsertWaypointAfter, showWaypointRadial: false });
  };

  const handleDeleteClick = () => {
    const selectedPlayer = getSelectedPlayer(state);
    if (selectedPlayer)
      deleteWaypoint(state, dispatch, selectedPlayer, state.selectedWaypoint);
    dispatch({ showWaypointRadial: false });
  };

  return (
    <Menu
      centerX={state.radialAnchor.x}
      centerY={state.radialAnchor.y}
      innerRadius={50}
      outerRadius={160}
      show={state.showWaypointRadial}
      animation={["fade", "scale"]}
      animationTimeout={120}
      theme='dark'
      drawBackground={true}
    >
      <MenuItem onItemClick={state.selectedWaypoint < (selectedPlayer?.points.length || 0) - 1 ? handleInsertAfterClick : undefined} data="">
        <RadialItem icon={faPlusCircle}  colour={state.selectedWaypoint < (selectedPlayer?.points.length || 0) - 1 ? undefined : theme.palette.dsNeutral.v400} text={i18n("builder.waypoint.insert.after")} />
      </MenuItem>
      <MenuItem onItemClick={state.selectedWaypoint > 0 ? handleInsertBeforeClick : undefined} data="">
        <RadialItem icon={faPlusCircle} colour={state.selectedWaypoint > 0 ? undefined : theme.palette.dsNeutral.v400} text={i18n("builder.waypoint.insert.before")} />
      </MenuItem>
      <MenuItem onItemClick={handleDeleteClick} data="">
        <RadialItem icon={faMinusCircle} text={i18n("builder.action.delete")} colour={theme.palette.dsDestructive.v200} />
      </MenuItem>
    </Menu>
  )
}

export default WaypointMenu;